import { Link } from 'react-router-dom';
import type { Character } from '@/types';

interface CharacterListProps {
  characters: Character[];
}

export default function CharacterList({ characters }: CharacterListProps) {
  if (characters.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-background-300/80 bg-background-100 px-6 py-10 text-center">
        <p className="text-sm text-foreground-600">本作品的角色资料正在整理中，敬请期待。</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5">
      {characters.map((c) => (
        <Link
          key={c.id}
          to={`/character/${c.id}`}
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
        >
          <div className="relative aspect-square w-full overflow-hidden bg-background-200">
            <img
              src={c.avatar}
              alt={`${c.name} 角色头像`}
              title={`${c.name} · ${c.actor} 饰`}
              className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute left-2 top-2 rounded bg-primary-900/85 px-2 py-0.5 font-label text-[10px] text-background-100">
              {c.roleTag}
            </span>
          </div>
          <div className="p-3 md:p-4">
            <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
              {c.name}
            </h3>
            <p className="mt-1 text-xs text-foreground-500">演员 · {c.actor}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}